import { lazyLoad } from 'utils/lazy';

export default lazyLoad(
  () => import('./EditProfile'),
  (m) => m.default
);
